export const PrispekServices = [
    {
        Summary: 'Wills',
        Details: [
            {
                Item: 'Making sure your estate gets dissolved quickly and, in the manner, you wished it would happen.'
            }
        ]
    },
    {
        Summary: 'Executorship',
        Details: [{ Item: 'Making your Will come true.' }]
    },
    {
        Summary: 'Estate Planning',
        Details: [
            {
                Item: 'Making sure your estate is wound up expediently and cost effectively for the benefit of your heirs'
            }
        ]
    },
    {
        Summary: 'Trusteeship',
        Details: [
            {
                Item: 'Looking after your dependants and beneficiaries as were your wish'
            }
        ]
    }
];
